module.exports = __webpack_public_path__ + "img/sheik-min.338448ca.png";